import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CMS_FEATURES } from './config/cms-features';
import CmsShellLayout from './layout/cms-shell-layout';
/**
 * Hash routes inside the CMS iframe (`#/card-schemas`, …). First feature is the default index redirect.
 */
export const CmsRouter = () => (_jsx("div", { className: "cms-mfe-root", children: _jsx(Routes, { children: _jsxs(Route, { element: _jsx(CmsShellLayout, {}), children: [_jsx(Route, { index: true, element: _jsx(Navigate, { to: CMS_FEATURES[0].pathSegment, replace: true }) }), CMS_FEATURES.map(feature => {
                    const FeatureRoutes = feature.RoutesComponent;
                    return (_jsx(Route, { path: `${feature.pathSegment}/*`, element: _jsx(FeatureRoutes, {}) }, feature.id));
                })] }) }) }));
